export default __webpack_public_path__ + "static/media/enrique-gaviglio.4c1a28a2.webp";